import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_select = _resolveComponent("a-select");
  return _openBlock(), _createBlock(_component_a_select, _mergeProps({
    options: $setup.depCateList,
    "field-names": $setup.fieldNames,
    loading: $setup.loading,
    error: $setup.error
  }, _ctx.$attrs, {
    "allow-clear": ""
  }), null, 16, ["options", "field-names", "loading", "error"]);
}